var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMergeDoCidadao = function SvgMergeDoCidadao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    d: "M11 18.5H1a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V19a.5.5 0 0 0-.5-.5zm0-18H1a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    d: "M6 25.8a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h3zm8.016-20c.946.107 1.64.924 1.61 1.86l-.01.148v7.064h3.976v.8h-3.96v7.176a1.816 1.816 0 0 1-1.453 1.985l-.147.023H12v-.8h2.032c.41 0 .752-.48.795-1.078l.005-.13V7.808c0-.612-.328-1.134-.716-1.2l-.084-.008H12v-.8h2.016zM9 21.8a1 1 0 0 1 0 2H3a1 1 0 0 1 0-2h6zm-3-14a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h3zm3-4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 15.8,
    r: 6.5,
    fill: "url(#b)",
    fillRule: "nonzero",
    stroke: "#BEBFCB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8C54",
    d: "M28 16.8a1 1 0 0 1 1 1v2.461c-1.114 1.033-2.447 1.546-4 1.539-1.551-.007-2.885-.52-4-1.539V17.8a1 1 0 0 1 1-1zm-3-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#873D00",
    d: "M24.92 18.085c.961 0 1.76-.737 1.92-1.279 0-.006-3.84-.006-3.84-.006.155.545.955 1.285 1.92 1.285z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMergeDoCidadao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/merge-do-cidadao.98767e66.svg";
export { ForwardRef as ReactComponent };